import hooks from './shipment-invoice-previews.hooks';

export default (app) => {
  const service = app.service('api/shipment-invoice-previews');
  service.hooks(hooks);
};
